class LocalStorageProvider {
    private data = {};

    public setItem(key: string, value: any) {
        if (typeof window === 'undefined') {
            this.data[key] = String(value);
        } else {
            window.localStorage.setItem(key, String(value));
        }
    }

    public getItem(key: string): string {
        if (typeof window === 'undefined') {
            return this.data[key];
        } else {
            const value = window.localStorage.getItem(key);

            if (!value || value === 'undefined' || value === 'null') {
                return null;
            }

            return value;
        }
    }

    public removeItem(key: string) {
        if (typeof window === 'undefined') {
            delete this.data[key];
        } else {
            window.localStorage.removeItem(key);
        }
    }
}

export const LocalStorageService = new LocalStorageProvider();
